// Chakra imports
import {
  Box,
  RadioGroup,
  Radio,
  HStack,
  Stack,
  Heading,
  Input,
  Button,
  useOutsideClick,
  useDisclosure,


} from "@chakra-ui/react";
import ChatBox from "./components/ChatBox";

import { React, useEffect, useState, useRef } from "react";
import MiniCalendar from "components/calendar/MiniCalendar";

import { useSelector, useDispatch } from "react-redux";
import { getTranscriptsData, putEditedTranscriptsData } from "../../../redux/actions/transcripts";
import { closeModal } from "../../../redux/actions/modal.js";
import * as type from "../../../redux/types";
import audioPlayer from '../../../assets/img/layout/audio-player.png';

import "./transcripts.css";

import moment from "moment";
import { FiCalendar } from "react-icons/fi";
import Pagination from './components/Pagination';
import callSumUser from '../../../assets/img/profile/userImg.png';


const UTC_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";

export default function Transcripts() {
  let limit = 25;
  let page = 1;
  let clientName = "Sobisco";

  const dispatch = useDispatch();
  const allTranscriptsData = useSelector(
    (state) => state.transcriptsData.transcriptsData
  );

  const state = useSelector(
    (state) => state
  );
  console.log("transcriptsData state", state);

  const userDataState = useSelector(state=>state.userData)

  const [selectedRadioButton, setSelectedRadioButton] = useState({
    isMobileNumber: false,
    isSessionId: false,
    isDateRange: false,
  });
  const [filteredTranscriptsData, setFilteredTranscriptsData] = useState([]);
  const [transcriptsToDisplay, setTranscriptsToDisplay] = useState([]);
  const [inputSessionId, setInputSessionId] = useState("");
  const [inputMobileNumber, setInputMobileNumber] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);

  const [selectedDateRange, setSelectedDateRange] = useState({});
  const [selectedTranscript, setSelectedTranscript] = useState([]);

  const [dateFromCalendar, setDateFromCalendar] = useState(new Date());

  const calenderRef = useRef()
  const { isOpen, onOpen, onClose } = useDisclosure()

  // useEffect(() => {
  //   console.log("$$$ transcriptsToDisplay", transcriptsToDisplay);
  // }, [transcriptsToDisplay]);


  useEffect(() => {
    setSelectedRadioButton((prevState) => ({
      ...prevState,
      isMobileNumber: false,
      isSessionId: false,
      isDateRange: true,
    }));

    setSelectedDateRange({
      ...selectedDateRange,
      startDate: moment()
        .utc()
        .set({ hours: "0", minutes: "0", seconds: "0" })
        .format(UTC_DATE_TIME_FORMAT),
      endDate: moment().utc().format(UTC_DATE_TIME_FORMAT),
    });
  }, []);

  useEffect(() => {
    if (selectedRadioButton.isMobileNumber) {
      const filteredData = allTranscriptsData.filter((item) => {
        return item.userId.startsWith(inputMobileNumber);
      });
      setFilteredTranscriptsData(filteredData);
    }
    if (selectedRadioButton.isSessionId) {
      const filteredData = allTranscriptsData.filter((item) => {
        return item.sessionId.startsWith(inputSessionId);
      });
      setFilteredTranscriptsData(filteredData);
    }
  }, [inputMobileNumber, inputSessionId]);

  useEffect(() => {
    setInputMobileNumber("");
    setInputSessionId("");
    setFilteredTranscriptsData(allTranscriptsData);
  }, [selectedRadioButton]);

  useEffect(() => {
    console.log("$$$$ selectedDateRange", selectedDateRange);
    if (selectedDateRange.startDate && selectedDateRange.endDate) {
      dispatch(
        getTranscriptsData({
          selectedDateRange,
          clientName,
          limit,
          page,
          token:userDataState.token
        })
      );
    }
  }, [selectedDateRange]);

  useEffect(() => {
    if (dateFromCalendar?.length == 2) {
      setSelectedDateRange({
        ...selectedDateRange,
        startDate: moment(dateFromCalendar[0]).utc().format("YYYY-MM-DD"),
        endDate: moment(dateFromCalendar[1]).utc().format("YYYY-MM-DD"),
      });
      setShowCalendar(false);
    }
  }, [dateFromCalendar]);

  useEffect(() => {

    console.log("Changed in state isDataUpdated", state.transcriptsData.isDataUpdated);
    {
      if (state.analyticsData.isDataUpdated) {
        dispatch(
          getTranscriptsData({
            selectedDateRange,
            clientName,
            limit,
            page,
            token:userDataState.token
          })
        );
      }
    }
  }, [state]);

  useOutsideClick({
    ref: calenderRef,
    handler: () => {
      setShowCalendar(false);
    },
  })


  const showTranscriptMessages = (id) => {
    const requiredTranscript = allTranscriptsData.find((item) => {
      return item._id === id;
    });
    setSelectedTranscript(requiredTranscript);
  };

  const handleChange = (e) => {
    if (selectedRadioButton.isMobileNumber) {
      setInputMobileNumber(e.target.value);
    }
    if (selectedRadioButton.isSessionId) {
      setInputSessionId(e.target.value);
    }
  };

  const saveTheUpdatedTranscript = (updatedTranscript) => {
    selectedTranscript.transcript = updatedTranscript;
    let finalPayload = {
      data:selectedTranscript,
      token:userDataState.token
    }
    dispatch(putEditedTranscriptsData(finalPayload));
  }

  const saveQaFeedback = (fullAnalyticsObj) => {

    let finalPayload = {
      data:fullAnalyticsObj,
      token:userDataState.token
    }
    dispatch(putEditedTranscriptsData(finalPayload));
    setSelectedTranscript(fullAnalyticsObj)
  }

  const updateResponseTimeToIndianTime = (value) => {
    let responseDate = new Date(value).toLocaleDateString('en-IN');
    let responseTime = new Date(value).toLocaleTimeString('en-IN');
    return responseDate + " " + responseTime;
  }


  return (
    <div className="main-page sbscoTranscriptContainer">
      <HStack>
        <Box width="55%" className="sbscoCampaign">
          <Heading>Search Call Campaign</Heading>
          <RadioGroup size="sm">
            <Stack direction="row" spacing="2">
              <Radio
                onClick={() => {
                  setSelectedRadioButton((prevState) => ({
                    ...prevState,
                    isMobileNumber: true,
                    isSessionId: false,
                    isDateRange: false,
                  }));
                }}
                isChecked={selectedRadioButton.isMobileNumber}
              >
                Mobile Number
              </Radio>
              <Radio
                onClick={() => {
                  setSelectedRadioButton((prevState) => ({
                    ...prevState,
                    isSessionId: true,
                    isMobileNumber: false,
                    isDateRange: false,
                  }));
                }}
                isChecked={selectedRadioButton.isSessionId}
              >
                Session ID
              </Radio>
              <Radio
                onClick={() => {
                  setSelectedRadioButton((prevState) => ({
                    ...prevState,
                    isDateRange: true,
                    isMobileNumber: false,
                    isSessionId: false,
                  }));
                }}
                isChecked={selectedRadioButton.isDateRange}
              >
                Date
              </Radio>
            </Stack>
          </RadioGroup>
          {selectedRadioButton.isMobileNumber ||
            selectedRadioButton.isSessionId ? (
            <Input
              m="5px"
              variant="filled"
              size="sm"
              placeholder={
                selectedRadioButton.isMobileNumber
                  ? "Enter Mobile Number"
                  : selectedRadioButton.isSessionId
                    ? "Enter Session ID"
                    : null
              }
              value={
                selectedRadioButton.isMobileNumber
                  ? inputMobileNumber
                  : selectedRadioButton.isSessionId
                    ? inputSessionId
                    : ""
              }
              htmlSize={4}
              width="95%"
              onChange={handleChange}
            />
          ) : null}
          <div ref={calenderRef}>
            {selectedRadioButton.isDateRange ? (
              <>
                <div className="campaignCalendar">
                  <Button
                    size="sm"
                    rightIcon={<FiCalendar />}
                    variant="outline"
                    colorScheme="blue"
                    borderRadius="2px"
                    display="block"
                    width="94%"
                    margin="auto"
                    onClick={() => {
                      setShowCalendar(!showCalendar);
                    }}
                  >
                    {selectedDateRange.startDate.split("T")[0] ==
                      selectedDateRange.endDate.split("T")[0]
                      ? selectedDateRange.startDate.split("T")[0]
                      : `${selectedDateRange.startDate.split("T")[0]} to ${selectedDateRange.endDate.split("T")[0]
                      }`}
                  </Button>
                </div>

                {showCalendar && (

                  <MiniCalendar
                    selectRange={true}
                    pos="absolute"
                    m="0 0 0 -10px"
                    border="2px solid black"
                    zIndex="1"
                    transform="scale(0.95)"
                    transformOrigin="top"
                    dateFromCalendar={dateFromCalendar}
                    setDateFromCalendar={setDateFromCalendar}
                  />

                )}

              </>
            ) : null}
          </div>
          <Box className="transcript-window" id="scroll-bar-style">
            {transcriptsToDisplay?.map((item) => (
              <div
                key={item._id}
                className={
                  item._id === selectedTranscript._id
                    ? "transcript-card-selected"
                    : "transcript-card"
                }
                onClick={() => {
                  showTranscriptMessages(item._id);
                }}
              >
                <p>{item.userId}</p>
                <p>{item.sessionId}</p>
                <p>{updateResponseTimeToIndianTime(item.response_time)}</p>
              </div>
            ))}
          </Box>
          <Pagination
            inputArray={
              selectedRadioButton.isMobileNumber ||
                selectedRadioButton.isSessionId
                ? filteredTranscriptsData
                : allTranscriptsData
            }
            setTranscriptsToDisplay={setTranscriptsToDisplay}
          />
        </Box>
        {/* <Box width="50%" className="sbscoCallDetails"> */}
        <Box width="120%" className="sbscoCallDetails">
          <Heading>Call Details</Heading>
          <div className="chat-window" id="scroll-bar-style">
            <ChatBox selectedTranscript={selectedTranscript} saveTheUpdatedTranscript={saveTheUpdatedTranscript} saveQaFeedback={saveQaFeedback} />
          </div>
        </Box>
        {/* <Box width="25%" className="sbscoCallSummary"> */}
        <Box className="sbscoCallSummary">
          <div className="callsummary-window" id="scroll-bar-style">
            <div className="userImg">
              <img src={callSumUser}></img>
            </div>
            <Heading>Call Summary</Heading>
            <div className="callDetails">
              <div className="userProfile">
                <h4>Customer Profile</h4>
                <div className="row">
                  <div className="sm-6"><label>Name</label></div>
                  <div className="sm-6"><p>Zakir S</p></div>
                </div>
                <div className="row">
                  <div className="sm-6"><label>Designation</label></div>
                  <div className="sm-6"><p>Sales Executive</p></div>
                </div>
                <div className="row">
                  <div className="sm-6"><label>Mobile Number</label></div>
                  <div className="sm-6"><p>7000585609</p></div>
                </div>
                <div className="row">
                  <div className="sm-6"><label>Gender</label></div>
                  <div className="sm-6"><p>Male</p></div>
                </div>
                <div className="row">
                  <div className="sm-6"><label>Region</label></div>
                  <div className="sm-6"><p>West Bengal</p></div>
                </div>
              </div>
              <div className="userProfile integration">
                <h4>Integration</h4>
                <div className="row">
                  <div className="sm-6"><label>ASR</label></div>
                  <div className="sm-6"><p>Deepgram</p></div>
                </div>
                <div className="row">
                  <div className="sm-6"><label>TTS</label></div>
                  <div className="sm-6"><p>VO Artist</p></div>
                </div>
                <div className="row">
                  <div className="sm-6"><label>Telephony</label></div>
                  <div className="sm-6"><p>Epicode</p></div>
                </div>
              </div>
              <div className="userProfile conversation">
                <h4>Conversation</h4>
                <div className="row">
                  <div className="sm-6"><label>Flow</label></div>
                  <div className="sm-6"><p>personal-loan</p></div>
                </div>
                <div className="row">
                  <div className="sm-6"><label>Call Type</label></div>
                  <div className="sm-6"><p>Internal UAT</p></div>
                </div>
                <div className="row">
                  <div className="sm-6"><label>Not Interested Reason</label></div>
                  <div className="sm-6"><p>Reason - Others</p></div>
                </div>
                <div className="row">
                  <div className="sm-6"><label>Description</label></div>
                  <div className="sm-6"><p>Callback time over</p></div>
                </div>
                <div className="row">
                  <div className="sm-6"><label>Language</label></div>
                  <div className="sm-6"><p>English</p></div>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </HStack>



    </div>
  );
}
